var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import './style/index.scss';
/**
 * @author tongxiaokang
 * @version 0.0.1
 */
export default class List extends React.PureComponent {
    render() {
        const _a = this.props, { prefixCls, children, className, style, renderHeader, renderFooter } = _a, restProps = __rest(_a, ["prefixCls", "children", "className", "style", "renderHeader", "renderFooter"]);
        return (<div className={cls(prefixCls, className)} style={style} {...restProps}>
        {renderHeader ? (<div className={`${prefixCls}-header`}>
            {typeof renderHeader === 'function' ? renderHeader() : renderHeader}
          </div>) : null}
        {children ? (<div className={`${prefixCls}-body`}>{children}</div>) : null}
        {renderFooter ? (<div className={`${prefixCls}-footer`}>
            {typeof renderFooter === 'function' ? renderFooter() : renderFooter}
          </div>) : null}
      </div>);
    }
}
List.defaultProps = {
    prefixCls: 'x-list'
};
